/* ==========================================================================
   HINJ theme JS
   1. Hero slideshow  2. Carousel drag-scroll  3. Mobile nav
   4. Cart drawer (open/close + section re-render)
   5. Product form (variant picker + AJAX add to cart)
   ========================================================================== */

(function () {
  "use strict";

  /* 1. HERO SLIDESHOW ------------------------------------------------- */
  const hero = document.getElementById("hero");
  if (hero) {
    const slides = hero.querySelectorAll(".hero__slide");
    const dots = hero.querySelectorAll(".hero__dot");
    let current = 0;
    let timer = null;

    // Slides after the first carry their image in data-hero-bg and are only
    // fetched when they're about to show, so they stay out of the initial page load.
    function setBg(i) {
      const s = slides[i];
      if (s && s.dataset.heroBg) {
        s.style.backgroundImage = "url('" + s.dataset.heroBg + "')";
        s.removeAttribute("data-hero-bg");
      }
    }

    function goTo(index) {
      slides[current].classList.remove("is-active");
      if (dots[current]) dots[current].classList.remove("is-active");
      current = (index + slides.length) % slides.length;
      setBg(current);
      slides[current].classList.add("is-active");
      if (dots[current]) dots[current].classList.add("is-active");
      setBg((current + 1) % slides.length); // prime the following slide
    }
    function play() { timer = setInterval(() => goTo(current + 1), 5500); }

    setBg(1); // prime the second slide once the deferred script runs
    dots.forEach((dot, i) => dot.addEventListener("click", () => { clearInterval(timer); goTo(i); play(); }));
    if (slides.length > 1) play();
  }

  /* 2. PRODUCT CAROUSELS ----------------------------------------------- */
  document.querySelectorAll("[data-carousel]").forEach((carousel) => {
    const track = carousel.querySelector("[data-carousel-track]");
    const bar = carousel.querySelector("[data-carousel-bar]");
    if (!track) return;

    let isDown = false, startX = 0, startScroll = 0, moved = false;

    track.addEventListener("pointerdown", (e) => {
      if (e.pointerType !== "mouse") return;
      isDown = true; moved = false;
      startX = e.clientX; startScroll = track.scrollLeft;
      // Do NOT capture the pointer here: capturing on pointerdown redirects the
      // ensuing click off the card's <a>, so a plain click never navigates.
      // Capture only once a real drag begins (in pointermove).
    });
    track.addEventListener("pointermove", (e) => {
      if (!isDown) return;
      // Self-heal: if the button was released while we weren't capturing (e.g. released
      // off-track before the drag threshold), the pointerup may have missed us and isDown
      // is stuck. A buttonless move means the drag is over — reset instead of scrolling.
      if (e.buttons === 0) { endDrag(); return; }
      const delta = e.clientX - startX;
      if (!moved && Math.abs(delta) > 5) {
        moved = true;
        track.classList.add("is-dragging");
        try { track.setPointerCapture(e.pointerId); } catch (_) {}
      }
      if (moved) track.scrollLeft = startScroll - delta;
    });
    function endDrag() { isDown = false; requestAnimationFrame(() => track.classList.remove("is-dragging")); }
    // Bound on window so a release anywhere (incl. off-track) always ends the drag.
    window.addEventListener("pointerup", endDrag);
    window.addEventListener("pointercancel", endDrag);
    track.addEventListener("click", (e) => { if (moved) { e.preventDefault(); moved = false; } }, true);

    // Geometry (scrollWidth/clientWidth) only changes on resize, so cache it and
    // read only scrollLeft on scroll — avoids a forced reflow on every scroll event.
    let sw = 0, cw = 0;
    function measure() { sw = track.scrollWidth; cw = track.clientWidth; }
    function updateBar() {
      if (!bar || !sw) return;
      const max = sw - cw;
      const visible = cw / sw;
      const progress = max > 0 ? track.scrollLeft / max : 0;
      // Composited transform instead of animating width/margin (which trigger layout).
      bar.style.transform =
        "translateX(" + progress * (1 - visible) * 100 + "%) scaleX(" + visible + ")";
    }
    track.addEventListener("scroll", updateBar, { passive: true });
    window.addEventListener("resize", () => { measure(); updateBar(); });
    requestAnimationFrame(() => { measure(); updateBar(); });
  });

  /* 3. MOBILE NAV -------------------------------------------------------- */
  const navToggle = document.getElementById("nav-toggle");
  const primaryNav = document.getElementById("primary-nav");
  if (navToggle && primaryNav) {
    navToggle.addEventListener("click", () => {
      const open = primaryNav.classList.toggle("is-open");
      navToggle.setAttribute("aria-expanded", String(open));
    });
  }
  document.querySelectorAll(".site-nav__item--has-mega > .site-nav__link").forEach((link) => {
    link.addEventListener("click", (e) => {
      if (window.matchMedia("(max-width: 900px)").matches) {
        e.preventDefault();
        link.parentElement.classList.toggle("is-open");
      }
    });
  });

  /* 4. CART DRAWER --------------------------------------------------------- */
  function drawer() { return document.getElementById("cart-drawer"); }
  function overlay() { return document.getElementById("cart-overlay"); }

  function openCart() {
    const d = drawer(), o = overlay();
    if (!d || !o) return;
    o.hidden = false;
    requestAnimationFrame(() => { o.classList.add("is-visible"); d.classList.add("is-open"); });
    d.setAttribute("aria-hidden", "false");
    document.body.classList.add("drawer-open");
  }
  function closeCart() {
    const d = drawer(), o = overlay();
    if (!d || !o) return;
    o.classList.remove("is-visible");
    d.classList.remove("is-open");
    d.setAttribute("aria-hidden", "true");
    document.body.classList.remove("drawer-open");
    o.addEventListener("transitionend", () => { o.hidden = true; }, { once: true });
  }

  // Re-render the drawer from the server after cart changes
  async function refreshCartDrawer() {
    try {
      const res = await fetch(window.location.pathname + "?sections=cart-drawer");
      const data = await res.json();
      const html = data["cart-drawer"];
      if (!html) return;
      const tpl = document.createElement("div");
      tpl.innerHTML = html;
      const newDrawer = tpl.querySelector("#cart-drawer");
      const oldDrawer = drawer();
      if (newDrawer && oldDrawer) oldDrawer.innerHTML = newDrawer.innerHTML;

      const cartRes = await fetch("/cart.js");
      const cart = await cartRes.json();
      const count = document.getElementById("cart-count");
      if (count) count.textContent = cart.item_count;
    } catch (e) { /* non-fatal */ }
  }

  // Change a line quantity (0 = remove), then re-render the drawer
  async function changeLine(key, quantity) {
    try {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      await refreshCartDrawer();
    } catch (e) { /* non-fatal */ }
  }

  // Quick-add a "Pairs well with" item, then open the drawer
  async function quickAdd(btn) {
    const id = btn.getAttribute("data-variant-id");
    if (!id) return;
    const label = btn.textContent;
    btn.disabled = true; btn.textContent = "Adding…";
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: Number(id), quantity: 1 })
      });
      if (!res.ok) throw new Error("add failed");
      btn.textContent = "Added ✓"; btn.classList.add("is-added");
      await refreshCartDrawer();
      openCart();
      setTimeout(() => { btn.textContent = label; btn.classList.remove("is-added"); btn.disabled = false; }, 1600);
    } catch (err) { btn.textContent = label; btn.disabled = false; }
  }

  document.addEventListener("click", (e) => {
    if (e.target.closest("#cart-open")) { e.preventDefault(); openCart(); }
    if (e.target.closest("#cart-close") || e.target === overlay()) closeCart();

    const pairAdd = e.target.closest("[data-pair-add]");
    if (pairAdd) { e.preventDefault(); quickAdd(pairAdd); return; }

    // Quantity stepper + remove inside the drawer
    const inc = e.target.closest("[data-qty-inc]");
    const dec = e.target.closest("[data-qty-dec]");
    const rm = e.target.closest("[data-qty-remove]");
    if (inc || dec || rm) {
      const line = e.target.closest(".cart-line");
      if (!line) return;
      const key = line.getAttribute("data-key");
      const valEl = line.querySelector("[data-qty-val]");
      const cur = valEl ? parseInt(valEl.textContent, 10) || 1 : 1;
      if (rm) { changeLine(key, 0); return; }
      changeLine(key, inc ? cur + 1 : Math.max(0, cur - 1));
      return;
    }

    // Order-note toggle
    const noteToggle = e.target.closest("[data-note-toggle]");
    if (noteToggle) {
      const wrap = document.querySelector("[data-note-wrap]");
      if (!wrap) return;
      const open = wrap.hidden;
      wrap.hidden = !open;
      noteToggle.setAttribute("aria-expanded", String(open));
      if (open) { const ta = wrap.querySelector("[data-note]"); if (ta) ta.focus(); }
    }
  });

  // Save the order note to the cart
  document.addEventListener("change", (e) => {
    const ta = e.target.closest("[data-note]");
    if (!ta) return;
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ note: ta.value })
    }).catch(() => {});
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && drawer() && drawer().classList.contains("is-open")) closeCart();
  });

  /* 5. PRODUCT FORM, variant picker + AJAX add ----------------------------- */
  const productRoot = document.querySelector("[data-product-root]");
  if (productRoot) {
    const form = productRoot.querySelector("#ProductForm") || productRoot.querySelector("form[action*='/cart/add']");
    const variantInput = productRoot.querySelector("[data-variant-id]");
    const priceEl = productRoot.querySelector("[data-price]");
    const addBtn = productRoot.querySelector("[data-add-to-bag]");
    const variantsScript = productRoot.querySelector("[data-variants-json]");
    const variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    const pickers = productRoot.querySelectorAll("[data-option-picker]");
    const buyLabel = addBtn ? addBtn.getAttribute("data-buy-label") || "Add To Bag" : "Add To Bag";

    // Stock line: reflects REAL inventory per selected variant (never a fabricated count)
    const stockEl = productRoot.querySelector("[data-stock]");
    const stockLow = stockEl ? (parseInt(stockEl.getAttribute("data-low"), 10) || 5) : 5;
    const isPreorder = stockEl ? stockEl.getAttribute("data-preorder") === "true" : false;
    const mtoLine = stockEl ? (stockEl.getAttribute("data-mto") || "") : "";
    function updateStock(match) {
      if (!stockEl) return;
      var txt = "", low = false;
      if (match.available) {
        if (isPreorder) { txt = mtoLine; }
        else if (match.tracked && typeof match.qty === "number" && match.qty > 0 && match.qty <= stockLow) {
          txt = "In Stock · Only " + match.qty + " Left"; low = true;
        } else { txt = "In Stock"; }
      }
      stockEl.textContent = txt;
      stockEl.hidden = !txt;
      stockEl.classList.toggle("is-low", low);
    }

    // Custom colour: picker fills the code field; custom dye must be confirmed
    const colourPicker = productRoot.querySelector("[data-colour-picker]");
    const colourCode = productRoot.querySelector("[data-colour-code]");
    const colourConfirm = productRoot.querySelector("[data-colour-confirm]");
    const confirmWrap = colourConfirm ? colourConfirm.closest(".custom-colour__confirm") : null;
    if (colourPicker && colourCode) {
      colourPicker.addEventListener("input", () => {
        colourCode.value = colourPicker.value.toUpperCase();
        if (confirmWrap) confirmWrap.classList.remove("is-error");
      });
    }
    if (colourConfirm && confirmWrap) {
      colourConfirm.addEventListener("change", () => confirmWrap.classList.remove("is-error"));
    }

    // Preset colour chips fill the picker + code and set the dye colour
    productRoot.querySelectorAll("[data-chip]").forEach((chip) => {
      chip.addEventListener("click", () => {
        const name = chip.getAttribute("data-name");
        const hex = chip.getAttribute("data-hex");
        if (colourPicker && /^#[0-9a-fA-F]{6}$/.test(hex)) colourPicker.value = hex;
        if (colourCode) { colourCode.value = name; colourCode.dispatchEvent(new Event("input", { bubbles: true })); }
        productRoot.querySelectorAll("[data-chip]").forEach((c) => c.classList.toggle("is-selected", c === chip));
        if (confirmWrap) confirmWrap.classList.remove("is-error");
      });
    });

    function selectedOptions() {
      return Array.from(pickers).map((p) => {
        const sel = p.querySelector(".is-selected");
        return sel ? sel.getAttribute("data-option-value") : null;
      });
    }

    function syncVariant() {
      if (!variants.length) return;
      const opts = selectedOptions();
      const match = variants.find((v) => v.options.every((o, i) => o === opts[i]));
      if (!match) return;
      if (variantInput) variantInput.value = match.id;
      if (priceEl) priceEl.innerHTML = (match.compare ? "<s>" + match.compare + "</s>&ensp;" : "") + match.price;
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? buyLabel : "Sold Out";
      }
      updateStock(match);
    }

    pickers.forEach((picker) => {
      picker.addEventListener("click", (e) => {
        const btn = e.target.closest("button");
        if (!btn) return;
        picker.querySelectorAll("button").forEach((b) => b.classList.remove("is-selected"));
        btn.classList.add("is-selected");
        syncVariant();
      });
    });

    if (form) {
      form.addEventListener("submit", async (e) => {
        e.preventDefault();
        const dyeFile = form.querySelector("[data-dye-input]");
        const hasDyeFile = dyeFile && dyeFile.files && dyeFile.files.length > 0;
        // custom dye is final sale: block until the buyer confirms — whether they typed a
        // colour code OR attached a reference photo (uploading a photo is the primary path).
        const dyeChosen = (colourCode && colourCode.value.trim()) || hasDyeFile;
        if (dyeChosen && colourConfirm && !colourConfirm.checked) {
          if (confirmWrap) {
            confirmWrap.classList.add("is-error");
            confirmWrap.scrollIntoView({ behavior: "smooth", block: "center" });
          }
          return;
        }
        // made-to-measure: block until measurements are double-checked
        const measureWrap = productRoot.querySelector("[data-measure-wrap]");
        const measureConfirm = productRoot.querySelector("[data-measure-confirm]");
        const fitUsed = Array.from(productRoot.querySelectorAll("[data-measure]")).some((el) => el.value.trim() !== "");
        if (fitUsed && measureConfirm && !measureConfirm.checked) {
          measureWrap.classList.add("is-error");
          measureWrap.scrollIntoView({ behavior: "smooth", block: "center" });
          return;
        }
        const properties = {};
        form.querySelectorAll("[name^='properties[']").forEach((el) => {
          if (el.type === "file") return; // files can't ride in JSON — sent via FormData below
          if ((el.type === "checkbox" || el.type === "radio") && !el.checked) return;
          const v = el.value.trim();
          if (v) properties[el.name.slice(11, -1)] = v;
        });
        if (addBtn) addBtn.textContent = "Adding…";
        try {
          let res;
          if (hasDyeFile) {
            // Multipart so the colour-reference photo uploads and attaches to the line item.
            const fd = new FormData();
            fd.append("id", String(Number(variantInput.value)));
            fd.append("quantity", "1");
            Object.keys(properties).forEach((k) => fd.append("properties[" + k + "]", properties[k]));
            fd.append("properties[Colour reference photo]", dyeFile.files[0]);
            res = await fetch("/cart/add.js", { method: "POST", headers: { "Accept": "application/json" }, body: fd });
          } else {
            res = await fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", "Accept": "application/json" },
              body: JSON.stringify({ id: Number(variantInput.value), quantity: 1, properties: properties })
            });
          }
          if (!res.ok) throw new Error("add failed");
          const sheila = productRoot.querySelector("[data-sheila-attach]");
          if (sheila && sheila.checked) {
            const sheilaProps = { "For": document.querySelector(".pdp__name").textContent.trim() };
            if (properties["Custom colour"]) sheilaProps["Dyed to match"] = properties["Custom colour"];
            await fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", "Accept": "application/json" },
              body: JSON.stringify({ id: Number(sheila.getAttribute("data-sheila-variant")), quantity: 1, properties: sheilaProps })
            }).catch(() => {});
            sheila.checked = false;
          }
          await refreshCartDrawer();
          openCart();
        } catch (err) {
          form.submit(); // graceful fallback to full-page add
        } finally {
          if (addBtn) addBtn.textContent = buyLabel;
        }
      });
    }
  }
})();

/* PDP: gallery — click a thumbnail to swap the main image, plus the
   see-it-on-a-different-model switcher */
(function () {
  var gallery = document.querySelector("[data-gallery]");
  if (!gallery) return;
  var thumbs = [].slice.call(gallery.querySelectorAll("[data-thumb-btn]"));
  var items = [].slice.call(gallery.querySelectorAll("[data-stage-item]"));

  // Sample the active photo's own backdrop and paint it behind the whole gallery,
  // so the image dissolves into the box seamlessly whatever colour it was shot on.
  function sampleBackdrop(img) {
    try {
      if (!img || !img.complete || !img.naturalWidth) return null;
      var w = Math.min(48, img.naturalWidth), h = Math.min(64, img.naturalHeight);
      var c = document.createElement("canvas"); c.width = w; c.height = h;
      var ctx = c.getContext("2d"); ctx.drawImage(img, 0, 0, w, h);
      var pts = [[1, 1], [w - 2, 1], [1, h - 2], [w - 2, h - 2]], r = 0, g = 0, b = 0;
      pts.forEach(function (p) { var d = ctx.getImageData(p[0], p[1], 1, 1).data; r += d[0]; g += d[1]; b += d[2]; });
      var n = pts.length;
      return "rgb(" + Math.round(r / n) + "," + Math.round(g / n) + "," + Math.round(b / n) + ")";
    } catch (e) { return null; }
  }
  function syncBackdrop() {
    var img = gallery.querySelector(".pdp__stage-item.is-active img");
    if (!img) return;
    var apply = function () { var col = sampleBackdrop(img); if (col) gallery.style.backgroundColor = col; };
    if (img.complete && img.naturalWidth) apply();
    else img.addEventListener("load", apply, { once: true });
  }

  function activate(index) {
    items.forEach(function (it) {
      var on = it.getAttribute("data-index") === String(index);
      it.classList.toggle("is-active", on);
      var v = it.querySelector("video");
      if (v && !on) { try { v.pause(); } catch (e) {} }
    });
    thumbs.forEach(function (t) {
      t.classList.toggle("is-active", t.getAttribute("data-thumb-index") === String(index));
    });
    syncBackdrop();
  }

  syncBackdrop();

  thumbs.forEach(function (t) {
    t.addEventListener("click", function () { activate(t.getAttribute("data-thumb-index")); });
  });

  gallery.querySelectorAll("[data-model-btn]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var grp = btn.getAttribute("data-model-btn");
      var first = items.filter(function (it) { return it.getAttribute("data-model-group") === grp; })[0];
      if (!first) return; /* no media for this model — ignore so the stage never blanks */
      gallery.setAttribute("data-active-model", grp);
      gallery.querySelectorAll("[data-model-btn]").forEach(function (b) {
        b.classList.toggle("is-active", b === btn);
      });
      activate(first.getAttribute("data-index"));
    });
  });

  // Swipe the main image left/right (touch) to step through photos of the active model
  var stage = gallery.querySelector("[data-stage]");
  if (stage) {
    function visibleItems() {
      var model = gallery.getAttribute("data-active-model") || "1";
      return items.filter(function (it) { return it.getAttribute("data-model-group") === model; });
    }
    function step(dir) {
      var vis = visibleItems();
      if (vis.length < 2) return;
      var cur = 0;
      for (var i = 0; i < vis.length; i++) { if (vis[i].classList.contains("is-active")) { cur = i; break; } }
      var next = (cur + dir + vis.length) % vis.length;
      activate(vis[next].getAttribute("data-index"));
    }
    // One-finger swipes only. A pinch (two fingers spreading sideways) or a drag
    // around a pinch-zoomed page used to read as a swipe and flip to another photo.
    var sx = 0, sy = 0, multi = false, tracking = false;
    stage.addEventListener("touchstart", function (e) {
      if (e.touches.length > 1) { multi = true; tracking = false; return; }
      multi = false; tracking = true;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener("touchmove", function (e) {
      if (e.touches.length > 1) { multi = true; tracking = false; }
    }, { passive: true });
    stage.addEventListener("touchend", function (e) {
      if (e.touches.length) return;               // wait for the last finger
      var ok = tracking && !multi;
      tracking = false; multi = false;
      if (!ok) return;
      if (window.visualViewport && window.visualViewport.scale > 1.05) return;  // zoomed page: that was a pan
      var dx = e.changedTouches[0].clientX - sx;
      var dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        stage.setAttribute("data-swiped", String(Date.now()));
        step(dx < 0 ? 1 : -1);
      }
    }, { passive: true });
    stage.addEventListener("touchcancel", function () { tracking = false; multi = false; }, { passive: true });
  }
})();


/* PDP: custom-fit expander, selection summary, mobile bar, share, whatsapp */
(function () {
  var root = document.querySelector("[data-product-root]");
  if (!root) return;

  // Made-to-measure popup (measurements only)
  var fitToggle = root.querySelector("[data-fit-toggle]");
  var fitFields = root.querySelector("[data-fit-fields]");
  var fitOverlay = root.querySelector("[data-fit-overlay]");
  if (fitToggle && fitFields) {
    function openFit() {
      fitFields.hidden = false;
      if (fitOverlay) fitOverlay.hidden = false;
      fitToggle.setAttribute("aria-expanded", "true");
      fitToggle.classList.add("is-open");
      document.body.style.overflow = "hidden";
    }
    function closeFit() {
      fitFields.hidden = true;
      if (fitOverlay) fitOverlay.hidden = true;
      fitToggle.setAttribute("aria-expanded", "false");
      fitToggle.classList.remove("is-open");
      document.body.style.overflow = "";
    }
    fitToggle.addEventListener("click", function () { fitFields.hidden ? openFit() : closeFit(); });
    root.querySelectorAll("[data-fit-close]").forEach(function (b) { b.addEventListener("click", closeFit); });
    if (fitOverlay) fitOverlay.addEventListener("click", closeFit);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !fitFields.hidden) closeFit(); });
  }

  // Match-my-shade upload popup (customer uploads a colour reference; it rides
  // along as a line-item property on add-to-cart — no WhatsApp needed).
  var dyeToggle = root.querySelector("[data-dye-toggle]");
  var dyeFields = root.querySelector("[data-dye-fields]");
  var dyeOverlay = root.querySelector("[data-dye-overlay]");
  if (dyeToggle && dyeFields) {
    function openDye() {
      dyeFields.hidden = false;
      if (dyeOverlay) dyeOverlay.hidden = false;
      dyeToggle.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";
    }
    function closeDye() {
      dyeFields.hidden = true;
      if (dyeOverlay) dyeOverlay.hidden = true;
      dyeToggle.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";
    }
    dyeToggle.addEventListener("click", function () { dyeFields.hidden ? openDye() : closeDye(); });
    root.querySelectorAll("[data-dye-close]").forEach(function (b) { b.addEventListener("click", closeDye); });
    if (dyeOverlay) dyeOverlay.addEventListener("click", closeDye);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !dyeFields.hidden) closeDye(); });

    var dyeInput = root.querySelector("[data-dye-input]");
    var dyeLabel = root.querySelector("[data-dye-label]");
    var dyePreview = root.querySelector("[data-dye-preview]");
    var dyeDrop = root.querySelector("[data-dye-drop]");
    if (dyeInput) {
      dyeInput.addEventListener("change", function () {
        var f = dyeInput.files && dyeInput.files[0];
        if (f) {
          if (dyePreview) { dyePreview.src = URL.createObjectURL(f); dyePreview.hidden = false; }
          if (dyeLabel) dyeLabel.textContent = f.name;
          if (dyeDrop) dyeDrop.classList.add("has-photo");
          dyeToggle.classList.add("has-photo");
          dyeToggle.textContent = "Photo attached ✓ change it";
        } else {
          if (dyePreview) dyePreview.hidden = true;
          if (dyeDrop) dyeDrop.classList.remove("has-photo");
          dyeToggle.classList.remove("has-photo");
        }
      });
    }
  }

  var summary = root.querySelector("[data-summary]");
  var summaryText = root.querySelector("[data-summary-text]");
  var measureWrap = root.querySelector("[data-measure-wrap]");
  var measureConfirm = root.querySelector("[data-measure-confirm]");

  // Any made-to-measure measurement the customer actively entered
  function mtmUsed() {
    var used = false;
    root.querySelectorAll("[data-measure]").forEach(function (el) { if (el.value.trim()) used = true; });
    return used;
  }

  function buildSummary() {
    if (!summary || !summaryText) return;
    var parts = [];
    root.querySelectorAll("[data-option-picker]").forEach(function (p) {
      var sel = p.querySelector(".is-selected");
      if (sel) parts.push(sel.getAttribute("data-option-value"));
    });
    var colour = root.querySelector("[data-colour-code]");
    if (colour && colour.value.trim()) parts.push("Custom colour: " + colour.value.trim());
    if (mtmUsed()) parts.push("Made to measure");
    if (parts.length) {
      summaryText.textContent = parts.join(" \u00b7 ");
      summary.hidden = false;
    } else {
      summary.hidden = true;
    }
    if (measureWrap) {
      var used = Array.from(root.querySelectorAll("[data-measure]")).some(function (el) { return el.value.trim() !== ""; });
      measureWrap.hidden = !used;
      if (!used && measureConfirm) { measureConfirm.checked = false; measureWrap.classList.remove("is-error"); }
    }
  }
  root.addEventListener("click", function (e) { if (e.target.closest("[data-option-picker] button")) setTimeout(buildSummary, 0); });
  root.addEventListener("input", function (e) {
    if (e.target.closest("[data-fit-field], [data-colour-code], [data-colour-picker]")) buildSummary();
  });
  root.addEventListener("change", function (e) {
    if (e.target.closest("[data-fit-field]")) buildSummary();
    if (e.target === measureConfirm && measureWrap) measureWrap.classList.remove("is-error");
  });
  buildSummary();

  var bar = document.querySelector("[data-mobile-bar]");
  var addBtn = root.querySelector("[data-add-to-bag]");
  if (bar && addBtn && "IntersectionObserver" in window) {
    var priceEl = root.querySelector("[data-price]");
    var barPrice = bar.querySelector("[data-mbar-price]");
    if (priceEl && barPrice) {
      new MutationObserver(function () { barPrice.textContent = priceEl.textContent.trim(); }).observe(priceEl, { childList: true, subtree: true });
    }
    new IntersectionObserver(function (entries) {
      bar.hidden = entries[0].isIntersecting;
    }, { rootMargin: "0px 0px -40px 0px" }).observe(addBtn);
    bar.querySelector("[data-mbar-buy]").addEventListener("click", function () { addBtn.click(); });
  }

  var share = document.querySelector("[data-share]");
  if (share) {
    share.addEventListener("click", function () {
      var payload = { title: share.getAttribute("data-share-title") || document.title, url: window.location.href.split("?")[0] };
      if (navigator.share) { navigator.share(payload).catch(function () {}); return; }
      navigator.clipboard.writeText(payload.url).then(function () {
        var t = share.textContent;
        share.textContent = "Link copied";
        setTimeout(function () { share.textContent = t; }, 1800);
      });
    });
  }

  var wa = document.querySelector("[data-wa-link]");
  if (wa) {
    wa.addEventListener("click", function () {
      var sel = [];
      root.querySelectorAll("[data-option-picker] .is-selected").forEach(function (b) { sel.push(b.getAttribute("data-option-value")); });
      if (sel.length) {
        var url = new URL(wa.href);
        var base = url.searchParams.get("text") || "";
        url.searchParams.set("text", base + " (" + sel.join(", ") + ")");
        wa.href = url.toString();
      }
    });
  }
})();


/* Tile films (gallery banners): nothing is fetched until a tile is about to scroll
   into view; then the poster and film load, play muted inline while visible and
   pause off-screen. Reduced-motion visitors keep the still poster. */
(function () {
  var vids = [].slice.call(document.querySelectorAll("video[data-lazy-video]"));
  if (!vids.length) return;
  var still = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function prime(v) {
    if (v.getAttribute("src")) return;
    var poster = v.getAttribute("data-poster");
    if (poster) v.setAttribute("poster", poster);
    v.muted = true; v.defaultMuted = true;
    if (!still) v.src = v.getAttribute("data-src");
  }
  function play(v) {
    prime(v);
    if (still) return;
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }
  if (!("IntersectionObserver" in window)) { vids.forEach(play); return; }
  var near = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { prime(e.target); near.unobserve(e.target); } });
  }, { rootMargin: "600px 0px" });
  var seen = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) play(e.target);
      else if (!e.target.paused) e.target.pause();
    });
  }, { rootMargin: "100px 0px" });
  vids.forEach(function (v) { near.observe(v); seen.observe(v); });
})();


/* Tile slideshows (gallery banners): stills cross-fade in turn. Only the first still
   is in the page; the next is fetched as the tile nears the screen, each later one
   while the one before it is showing. The cycle runs only while the tile is on
   screen and the tab is visible, and never moves on to a still that has not finished
   loading. Reduced-motion visitors keep the first still. */
(function () {
  var boxes = [].slice.call(document.querySelectorAll("[data-tile-slides]"));
  if (!boxes.length) return;
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  var FADE = 1700;
  function hydrate(img) {
    var ss = img.getAttribute("data-srcset"), s = img.getAttribute("data-src");
    if (ss) { img.setAttribute("srcset", ss); img.removeAttribute("data-srcset"); }
    if (s) { img.setAttribute("src", s); img.removeAttribute("data-src"); }
  }
  function loaded(img) {
    hydrate(img);
    var done = img.complete && img.naturalWidth
      ? Promise.resolve()
      : new Promise(function (res) {
          img.addEventListener("load", res, { once: true });
          img.addEventListener("error", res, { once: true });
        });
    return done.then(function () { return img.decode ? img.decode().catch(function () {}) : null; });
  }
  boxes.forEach(function (box) {
    var slides = [].slice.call(box.querySelectorAll(".image-banner__slide"));
    if (slides.length < 2) return;
    var wait = Math.max(3, parseFloat(box.getAttribute("data-seconds")) || 5) * 1000;
    var i = 0, timer = null, busy = false, onScreen = false, started = false;
    function running() { return onScreen && !document.hidden; }
    function schedule() {
      if (timer || busy || !running()) return;
      if (!started) { started = true; slides[0].classList.add("is-moving"); }
      timer = setTimeout(advance, wait);
    }
    function halt() { if (timer) { clearTimeout(timer); timer = null; } }
    function advance() {
      timer = null;
      if (busy || !running()) return;
      busy = true;
      var cur = slides[i], j = (i + 1) % slides.length, nxt = slides[j];
      loaded(nxt).then(function () {
        busy = false;
        if (!running()) return;
        nxt.classList.add("is-active", "is-moving");
        cur.classList.remove("is-active");
        setTimeout(function () { if (!cur.classList.contains("is-active")) cur.classList.remove("is-moving"); }, FADE);
        i = j;
        hydrate(slides[(j + 1) % slides.length]);
        schedule();
      });
    }
    if (!("IntersectionObserver" in window)) { hydrate(slides[1]); onScreen = true; schedule(); return; }
    new IntersectionObserver(function (entries, obs) {
      if (entries[0].isIntersecting) { hydrate(slides[1]); obs.disconnect(); }
    }, { rootMargin: "600px 0px" }).observe(box);
    new IntersectionObserver(function (entries) {
      onScreen = entries[0].isIntersecting;
      if (onScreen) schedule(); else halt();
    }, { threshold: 0.2 }).observe(box);
    document.addEventListener("visibilitychange", function () { if (document.hidden) halt(); else schedule(); });
  });
})();
